"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasStatus = exports.getStatus = exports.encoreContextStatus = exports.encoreContextKeyword = exports.EncoreContextDefault = exports.EncoreContext = void 0;
var _react = _interopRequireDefault(require("react"));
var encoreContextStatus = exports.encoreContextStatus = {
  experimental: 'experimental',
  next: 'next',
  deprecated: 'deprecated'
};
var encoreContextKeyword = exports.encoreContextKeyword = {
  button: 'button',
  list: 'list',
  chip: 'chip',
  logospotifyadvertising: 'logospotifyadvertising'
};

/*
 * Lifecycle statuses to manage different versions component behavior.
 * Available keys:
 *  'button': { deprecated: ['button'] } will render a different type variant that is a smaller font size.
 *  'chip': { next: ['chip'] } will render a new Chip component with new features and no trailing margin.
 * @default {}
 */

var EncoreContextDefault = exports.EncoreContextDefault = {
  experimental: [],
  next: [],
  deprecated: []
};
var hasStatus = exports.hasStatus = function hasStatus(keyword, status) {
  return status.indexOf(keyword) > -1;
};
var getStatus = exports.getStatus = function getStatus(keyword, config) {
  var lifecycle = undefined;
  var statusKeys = Object.keys(encoreContextStatus);
  statusKeys.forEach(function (status) {
    if (hasStatus(keyword, config[status])) lifecycle = status;
  });
  return lifecycle;
};
var EncoreContext = exports.EncoreContext = /*#__PURE__*/_react["default"].createContext(EncoreContextDefault);
EncoreContext.displayName = 'Encore';